import { NgModule } from '@angular/core';
import { NoContentComponent } from './no-content';
import { SharedModule } from '../../shared';
import { AuditPageComponent } from './audit-page.component';
import { LoginComponent } from './login.component';

/**
 * `LoginModule`
 */
@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        LoginComponent
    ]
})
export class LoginModule {
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.module.ts